import { useHttp } from '../http'

export const useAdviceHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`advices/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`advices`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`advices/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`advices`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`advices/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}
